import * as React from 'react';
import { observer } from 'mobx-react';

import { ContextService } from 'src/core/services/context.service';
import { TourItineraryFormView } from './tour-itinerary.view';

interface Props extends ComponentViewProps<TourItineraryItem> {
	mode: ControlMode;
	contextService: ContextService;
	product: ProductItem;
}

@observer
export class TourItineraryFormController extends React.Component<Props, {}> {
	render(): React.ReactNode {
		const { contextService, mode, model, product, setBusy } = this.props;
		return (
			<TourItineraryFormView
				mode={mode}
				setBusy={setBusy}
				contextService={contextService}
				model={model}
				product={product}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/form/tour-itinerary.controller.tsx